module.exports = __webpack_public_path__ + "img/crm-stuff.c418e613.png";